// Register.js
import React, { useState } from 'react'
import supabase from './supabaseClient'

import { useNavigate } from 'react-router-dom'

export default function Register() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [message, setMessage] = useState('')
  const navigate = useNavigate()

  const handleRegister = async () => {
    setMessage('')
    if (!email || !password || !confirm) {
      setMessage('Заполните все поля')
      return
    }
    if (password !== confirm) {
      setMessage('Пароли не совпадают')
      return
    }
    const { error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        emailRedirectTo: window.location.origin
      }
    })
    if (error) setMessage('Ошибка: ' + error.message)
    else {
      setMessage('Регистрация успешна. Подтвердите email.')
      setEmail('')
      setPassword('')
      setConfirm('')
      setTimeout(() => navigate('/'), 3000)
    }
  }

  return (
    <div style={{ maxWidth: 400, margin: 'auto', padding: '2rem' }}>
      <h2>Регистрация</h2>
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{ width: '100%', marginBottom: 10 }}
      />
      <input
        type="password"
        placeholder="Пароль"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={{ width: '100%', marginBottom: 10 }}
      />
      <input
        type="password"
        placeholder="Подтвердите пароль"
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
        style={{ width: '100%', marginBottom: 10 }}
      />
      <button onClick={handleRegister}>Зарегистрироваться</button>
      <p>{message}</p>
    </div>
  )
}
